import { CdkTrapFocus } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseComponent, DialogRef } from '@shared/classes';
import { ButtonComponent } from '@shared/components/button/button.component';
import { StepChallenge } from '@shared/factory';
import {
  DIALOG_DATA,
  DialogCloseButton,
  Dict,
  ScopeInfoDialog,
} from '@shared/models';

@Component({
  selector: 'b2c-scope-info-modal',
  styleUrl: './scope-info-modal.component.scss',
  templateUrl: './scope-info-modal.component.html',
  imports: [ButtonComponent, CdkTrapFocus],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScopeInfoModalComponent extends BaseComponent {
  public readonly config: ScopeInfoDialog = this.loyaltyChallengeConfig
    .components.modals.scopeInfo as ScopeInfoDialog;

  public readonly closeButtonConfig: DialogCloseButton =
    this.loyaltyChallengeConfig.components.modals.closeButton;

  public readonly data: StepChallenge = inject<{ data: StepChallenge }>(
    DIALOG_DATA
  ).data;

  // Plain fields, not computed(): DIALOG_DATA hands over a plain StepChallenge
  // and LOCALE_ID is a constant, so there is nothing reactive to track.
  //
  // Challenge label — the same text the card's subheader shows.
  public readonly title: string = this.localised(this.data.productScope.label);

  // BO "Additional information" of the challenge's product scope.
  public readonly body: string = this.localised(
    this.data.productScope.description
  );

  private readonly dialogRef: DialogRef = inject(DialogRef);

  closeDialog(): void {
    this.dialogRef.close();
  }

  private localised(dict: Dict): string {
    const value = dict[this.locale.substring(0, 2)];
    return value ? `${value}` : '';
  }
}
